import { config } from "@financial-advisory/config";
import { type BaseQueryFn, type FetchArgs, type FetchBaseQueryError, createApi } from "@reduxjs/toolkit/query/react";
import { createBaseQuery } from "../baseQuery";
import { isUncheckUser, StateWithAuth } from "./tenantBasedUiSwitch";


const baseQueryIngestionService = createBaseQuery(config.INGESTION_SERVICE_API_BASE_URL);
const baseQueryUncheckService = createBaseQuery(config.UNCHECK_SERVICE_API_BASE_URL);

/**
 * Dynamically switches the base query depending on the tenant the user belongs to.
 *
 * This is here so that we can adapt the existing UI to use in Uncheck. The original UI has its data served by the
 * `ingestion-service`, and is a static piece of data uploaded as a ZIP file. The PDFs themselves fixed and are served
 * as static files by the webserver. The Uncheck UI has its data served by the `uncheck-service` and can serve dynamic
 * content (both decision processes and PDFs) based on the URL. Long term, `ingestion-service` will probably go away.
 */
const dynamicBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> =
    async (args, api, extraOptions) => {
        const baseQuery = isUncheckUser(api.getState() as StateWithAuth) ? baseQueryUncheckService : baseQueryIngestionService;
        return baseQuery(args, api, extraOptions);
    };

export const ingestionApi = createApi({
    reducerPath: "ingestionApi",
    baseQuery: dynamicBaseQuery,
    endpoints: () => ({}),
    tagTypes: ["ProcessedClause"],
});
